import Vue from 'vue'

export default Vue.extend({
    data() {
        return {}
    },
    methods: {
        showModal(id) {
            this.$bvModal.show(id)
        },
        closeModal(id) {
            this.$bvModal.hide(id)
        },
    },
})
